import { createValidIcon } from '@ui/icons/utils/type-helper'

export const CandlestickIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M12 9C12.5523 9 13 9.44771 13 10V12.1738C14.1647 12.5859 15 13.6941 15 15V17C15 18.3057 14.1645 19.413 13 19.8252V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V19.8252C9.83548 19.413 9 18.3057 9 17V15C9 13.6941 9.83532 12.5859 11 12.1738V10C11 9.44771 11.4477 9 12 9ZM5 5C5.55228 5 6 5.44772 6 6V8.17383C7.16468 8.58594 8 9.69415 8 11V15L7.99609 15.1543C7.93335 16.3927 7.11836 17.4293 6 17.8252V21C6 21.5523 5.55228 22 5 22C4.44772 22 4 21.5523 4 21V17.8252C2.88164 17.4293 2.06665 16.3927 2.00391 15.1543L2 15V11C2 9.69415 2.83532 8.58594 4 8.17383V6C4 5.44772 4.44772 5 5 5ZM19 1C19.5523 1 20 1.44772 20 2V5.17383C21.1647 5.58594 22 6.69415 22 8V14C22 15.3057 21.1645 16.413 20 16.8252V19C20 19.5523 19.5523 20 19 20C18.4477 20 18 19.5523 18 19V16.8252C16.8355 16.413 16 15.3057 16 14V8C16 6.69415 16.8353 5.58594 18 5.17383V2C18 1.44772 18.4477 1 19 1ZM12 14C11.4477 14 11 14.4477 11 15V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V15C13 14.4477 12.5523 14 12 14ZM5 10C4.44772 10 4 10.4477 4 11V15C4 15.5523 4.44772 16 5 16C5.55228 16 6 15.5523 6 15V11C6 10.4477 5.55228 10 5 10ZM19 7C18.4477 7 18 7.44772 18 8V14C18 14.5523 18.4477 15 19 15C19.5523 15 20 14.5523 20 14V8C20 7.44772 19.5523 7 19 7Z'
        fill={color}
      />
    </svg>
  )
})
